import { WidgetHeaderTypes } from "models/Widget";
import { StyledWrapper } from "styled-components/Common/CommonStyled";
import { StyledMessage, StyledTitle } from "styled-components/WidgetBuilder/WidgetBuilderStyled";

type WelcomeMessageProps = {
	header?: WidgetHeaderTypes;
	isMobile?: boolean;
};

const WelcomeMessage = (props: WelcomeMessageProps) => {
	const { header, isMobile = false } = props;
	const { title, message, fontSize: headerFontSize } = header || {};

	return (
		<StyledWrapper margin="24px 0 0 0">
			{title && (
				<StyledTitle isMobile={isMobile} fontSize={headerFontSize}>
					{title}
				</StyledTitle>
			)}
			{message && (
				<StyledMessage isMobile={isMobile} dangerouslySetInnerHTML={{ __html: message }} />
			)}
		</StyledWrapper>
	);
};

export default WelcomeMessage;
